import {
    SET_INACTIVITY
} from "@actions/actionTypes";

export function toggleInactivityAction(payload) {
    return dispatch => {
        dispatch({type: SET_INACTIVITY, payload});
    }
}